/* Loaded via <script src="{{ 'loxa-nectar.js' | asset_url }}" defer> in scripts.liquid. */
(function () {
  // ─── Page gate ─────────────────────────────────────────────────────────────
  if (!/\/products\//.test(window.location.pathname)) return;
  var body = document.body;
  if (!body) return;

  var TEMPLATE = (function () {
    var cls = body.classList;
    if (cls.contains("product--template-2026")) return "mattress";
    if (cls.contains("product--template-bedframe")) return "bedframe";
    // Nectar uses several shopify-bundle template variants:
    //   product--template-shopify-bundle              (Classic Starter Bundle)
    //   product--template-shopify-bundle.premier      (Premier Bundle)
    //   product--template-shopify-bundle.hybrid       (Hybrid variants — guess)
    // Check class list as strings since the `.` makes contains() too strict.
    for (var i = 0; i < cls.length; i++) {
      if (cls[i].indexOf("product--template-shopify-bundle") === 0) {
        return "bundle";
      }
    }
    return "unknown";
  })();
  if (TEMPLATE === "unknown") return;

  var ANCHOR_ID = "loxa-shopify-addon-anchor";
  var OFFER_ID = "loxa-shopify-offer";
  var CHECKBOX_ID = "loxa-insurance-checkbox";
  var TITLE_CLASS = "loxa-add-on-title";
  var ANCHOR_SELECTOR =
    TEMPLATE === "mattress"
      ? ".product-form__atc-wrapper"
      : TEMPLATE === "bundle"
      ? ".bundle-builder .button-area"
      : ".product-form__buttons";
  var DEFAULT_TERM = "5";
  var LOXA_LOGO_URL =
    "https://bolt-cover-assets.s3.eu-west-1.amazonaws.com/logo/LOXA_Stacked+Logo-Lime+on+Black.svg";
  var HEADER_MARKER = "X-Loxa-Separate-Add"; // header we set on bypass calls

  // ─── Module state ──────────────────────────────────────────────────────────
  var Dev = null;                  // LoxaShopifyDev, once available
  var insuranceMapPromise = null;  // pre-fetched insurance map
  var quoteCache = {};             // variantId → normalised quote
  var lastVariantId = null;        // currently-selected product variant
  var lastFrameVid = null;         // mattress: currently-selected frame variant
  var lastProductId = null;        // mattress: product id (for swap detection)

  // ─── Wait for LoxaShopifyDev ───────────────────────────────────────────────
  function waitForDev(cb, attempt) {
    attempt = attempt || 0;
    var D = window.LoxaShopifyDev;
    if (
      D &&
      typeof D.fetchInsurance === "function" &&
      typeof D.getInsuranceMap === "function" &&
      typeof D.findInsuranceVariantByPrice === "function"
    ) {
      cb(D);
      return;
    }
    if (attempt > 80) {
      console.warn("[Loxa Nectar] LoxaShopifyDev not available after 8s");
      return;
    }
    setTimeout(function () {
      waitForDev(cb, attempt + 1);
    }, 100);
  }

  // ─── DOM helpers ───────────────────────────────────────────────────────────
  // The form's hidden `name="id"` input is what /cart/add.js posts. The
  // ATC interceptor reads from there (so upsell-modal swaps land correctly
  // in the cart). For DISPLAY purposes, though, Nectar's theme rewrites
  // this field for upsell targeting (e.g. swap to a mattress-protector
  // variant a couple of seconds after ATC). Following that for our offer
  // card would re-quote against the upsell product and hide the card if
  // it's not insurable. So display callers use displayVariantId() which
  // prefers ShopifyAnalytics.meta.selectedVariantId — that reflects the
  // user's real selection on the PDP and isn't poisoned by upsell swaps.
  function currentVariantId() {
    var input = document.querySelector(
      'form[action="/cart/add"] input[name="id"]',
    );
    return input && input.value ? String(input.value) : null;
  }

  function displayVariantId() {
    try {
      var vid =
        window.ShopifyAnalytics &&
        ShopifyAnalytics.meta &&
        ShopifyAnalytics.meta.selectedVariantId;
      if (vid) return String(vid);
    } catch (e) {}
    return currentVariantId();
  }

  function currentVariantInfoFromAnalytics() {
    try {
      var meta =
        window.ShopifyAnalytics &&
        ShopifyAnalytics.meta &&
        ShopifyAnalytics.meta.product;
      if (!meta || !Array.isArray(meta.variants)) return null;
      var vid = displayVariantId();
      if (!vid) return null;
      var v = meta.variants.find(function (x) {
        return String(x.id) === String(vid);
      });
      if (!v) return null;
      return {
        title: v.name || meta.title || null,
        pricePounds: typeof v.price === "number" ? v.price / 100 : null,
      };
    } catch (e) {
      return null;
    }
  }

  function getSelectedFrameInput() {
    var inputs = document.querySelectorAll(
      "[data-product-mattress-bundler-single-select-checkbox]",
    );
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked && inputs[i].value && inputs[i].value !== "0") {
        return inputs[i];
      }
    }
    return null;
  }

  // ─── Offer card render ─────────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById("loxa-nectar-styles")) return;
    var style = document.createElement("style");
    style.id = "loxa-nectar-styles";
    style.textContent =
      // Wrap heading + offer card as one rounded panel.
      "#" + ANCHOR_ID + " { background: #f5f7fc; border-radius: 8px; padding: 12px 16px; margin: 16px 0; }" +
      // Heading inside the panel — rendered as <h6> so it inherits the
      // theme's h6 typography. We only override colour, weight, and
      // bottom margin to line up with Nectar's vertical rhythm.
      ".loxa-protect-heading { font-weight: 600; margin: 0 0 16px; color: #262b38; }" +
      // The card sits inside the panel — no its own border-radius/margin,
      // background already set on the wrapper.
      "#loxa-shopify-offer.loxa-add-on-badge { background: transparent; padding: 0; margin: 0; border-radius: 0; }" +
      // Offer-card layout (See Details pushed right).
      "#loxa-shopify-offer .loxa-add-on-main { display: flex; align-items: center; gap: 10px; }" +
      "#loxa-shopify-offer .loxa-details-link { margin-left: auto; }" +
      "#loxa-shopify-offer .loxa-offer-checkbox { width: 16px !important; height: 16px !important; }" +
      "#loxa-shopify-offer .loxa-add-on-logo { display: none !important; }" +
      // Hide the empty Liquid fallback so the offer card doesn't double-render.
      "#loxa-addon-fallback-template { display: none !important; }" +
      // The whole anchor (heading + card) starts hidden; we reveal once
      // we have an insurable quote in hand.
      "#" + ANCHOR_ID + " { display: none; }" +
      "#" + ANCHOR_ID + ".loxa-ready { display: block; }" +
      // Override the Loxa Shopify block's `<style id='loxa-liquid-hide-insurance'>`
      // which hides every cart-line matching the insurance variant id when
      // cart_mode is 'separate'. We render insurance as a normal visible
      // cart line; restore display. Kept as defence-in-depth even when the
      // block's cart_mode is set to 'bundled' (which stops the hide-CSS at
      // source).
      "cart-drawer tr.cart-item[data-handle='loxa-insurance'] { display: grid !important; }" +
      "tr.cart-item[data-handle='loxa-insurance'] { display: grid !important; }" +
      // Sidebar — Nectar-branded overrides.
      // Match Nectar's cart drawer width (~510px on desktop).
      "body #loxa-shopify-sidebar { max-width: 510px !important; }" +
      // Header background → white, dark text (logo restored).
      "body #loxa-shopify-sidebar .loxa-sidebar-header { background: #ffffff !important; color: #111827 !important; border-bottom: 1px solid #E5E7EB; }" +
      "body #loxa-shopify-sidebar .loxa-sidebar-header img { display: block !important; }" +
      "body #loxa-shopify-sidebar .loxa-sidebar-close { color: #586280 !important; }" +
      "body #loxa-shopify-sidebar .loxa-sidebar-close:hover { color: #111827 !important; }" +
      // CTA (action button) → Nectar blue, white text. Selectors prefixed
      // with `body` to bump specificity above the base rule in
      // loxa-shopify.css which uses background:#111827!important.
      "body #loxa-shopify-sidebar .loxa-sidebar-cta { background: #133ebf !important; background-color: #133ebf !important; color: #ffffff !important; }" +
      "body #loxa-shopify-sidebar .loxa-sidebar-cta:hover { opacity: 0.92; }";
    (document.head || document.documentElement).appendChild(style);
  }

  function injectAnchor() {
    if (document.getElementById(ANCHOR_ID)) return true;
    var target = document.querySelector(ANCHOR_SELECTOR);
    if (!target || !target.parentNode) {
      console.warn("[Loxa Nectar] anchor target missing:", ANCHOR_SELECTOR);
      return false;
    }
    var wrapper = document.createElement("div");
    wrapper.id = ANCHOR_ID;
    wrapper.setAttribute("data-loxa-shopify-anchor", "addon");
    target.parentNode.insertBefore(wrapper, target);
    return true;
  }

  function renderOfferCard(initialTitleText) {
    var anchor = document.getElementById(ANCHOR_ID);
    if (!anchor) return;
    anchor.innerHTML =
      '<h6 class="loxa-protect-heading">Protect your purchase</h6>' +
      '<div id="' +
      OFFER_ID +
      '" class="loxa-card loxa-add-on-badge" data-loxa-card-type="addon">' +
      '<div class="loxa-add-on-inner">' +
      '<div class="loxa-add-on-main">' +
      '<input id="' +
      CHECKBOX_ID +
      '" type="checkbox" class="loxa-offer-checkbox" />' +
      '<img src="' +
      LOXA_LOGO_URL +
      '" alt="Loxa" class="loxa-add-on-logo" width="24" height="28" />' +
      '<span class="' +
      TITLE_CLASS +
      '">' +
      escapeHtml(initialTitleText) +
      "</span>" +
      '<button class="loxa-learn-more-link loxa-details-link" type="button">' +
      '<span class="loxa-learn-more-link-text">See Details</span>' +
      "</button>" +
      "</div>" +
      "</div>" +
      "</div>";
    var detailsBtn = anchor.querySelector(".loxa-details-link");
    if (detailsBtn) detailsBtn.addEventListener("click", openSidebar);
  }

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  // ─── Sidebar (See Details) ────────────────────────────────────────────────
  // Renders the 5-Year plan's sidebar content from the proxy response.
  // CTA ticks #loxa-insurance-checkbox + closes the sidebar; customer still
  // clicks the page's main ATC themselves.
  //
  // The Loxa Shopify block already mounts the shell:
  //   <div id="loxa-shopify-sidebar"> with <div id="loxa-shopify-sidebar-content">
  //   <div id="loxa-shopify-sidebar-overlay">
  // and ships matching CSS. We populate the content and toggle open classes.
  var SIDEBAR_TICK_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
    '<path fill="#2e8462" d="M7.98 14.646a.9.9 0 0 1-.324-.063.9.9 0 0 1-.302-.208l-3.52-3.52a.83.83 0 0 1-.24-.636.9.9 0 0 1 .26-.636.85.85 0 0 1 .625-.25q.375 0 .625.25L8.021 12.5l6.896-6.896a.84.84 0 0 1 .614-.25q.365 0 .615.25t.25.615a.84.84 0 0 1-.25.614l-7.542 7.542a.9.9 0 0 1-.302.208.9.9 0 0 1-.323.063"/>' +
    "</svg>";

  function openSidebar() {
    var sidebar = document.getElementById("loxa-shopify-sidebar");
    var content = document.getElementById("loxa-shopify-sidebar-content");
    var overlay = document.getElementById("loxa-shopify-sidebar-overlay");
    if (!sidebar || !content) return;

    renderSidebarContent(content);

    // Position the panel on the right.
    sidebar.style.right = "0";
    sidebar.style.left = "";
    sidebar.classList.add("loxa-sidebar-open");
    if (overlay) overlay.classList.add("loxa-open");
    document.body.style.overflow = "hidden";

    // Wire close handlers (idempotent — bound once per open).
    bindSidebarClose();
  }

  function closeSidebar() {
    var sidebar = document.getElementById("loxa-shopify-sidebar");
    var overlay = document.getElementById("loxa-shopify-sidebar-overlay");
    if (sidebar) {
      sidebar.style.right = "-100%";
      sidebar.classList.remove("loxa-sidebar-open");
    }
    if (overlay) overlay.classList.remove("loxa-open");
    document.body.style.overflow = "";
  }

  function bindSidebarClose() {
    var sidebar = document.getElementById("loxa-shopify-sidebar");
    var overlay = document.getElementById("loxa-shopify-sidebar-overlay");
    var closeBtn = sidebar && sidebar.querySelector(".loxa-sidebar-close");

    if (closeBtn && !closeBtn._loxaBound) {
      closeBtn._loxaBound = true;
      closeBtn.addEventListener("click", closeSidebar);
    }
    if (overlay && !overlay._loxaBound) {
      overlay._loxaBound = true;
      overlay.addEventListener("click", closeSidebar);
    }
    if (!document._loxaEscBound) {
      document._loxaEscBound = true;
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") closeSidebar();
      });
    }
  }

  function renderSidebarContent(content) {
    // Pull the 5-Year plan's sidebar content. Prefer the mattress's plan
    // (the bedframe page uses its own plan). The frame's plan, if any, is
    // identical content-wise — it's the same template for Furniture.
    var sourceQuote = lastVariantId ? quoteCache[String(lastVariantId)] : null;
    if (!sourceQuote) {
      content.innerHTML = '<p style="padding:20px;">Loading protection details…</p>';
      return;
    }

    var plan = pickInsuranceForTerm(sourceQuote, DEFAULT_TERM);
    if (!plan) {
      content.innerHTML = '<p style="padding:20px;">Protection unavailable for this product.</p>';
      return;
    }
    var sidebar = (plan.insurance_content && plan.insurance_content.sidebar_content) || {};

    // Compute the combined premium (mattress + frame on mattress PDP).
    var total = premiumOf(plan);
    if (TEMPLATE === "mattress" && lastFrameVid) {
      var fq = quoteCache[String(lastFrameVid)];
      if (fq) {
        var fPlan = pickInsuranceForTerm(fq, DEFAULT_TERM);
        if (fPlan) total += premiumOf(fPlan);
      }
    }

    var header = escapeHtml(sidebar.header || "Add Protection, Enjoy Peace of Mind");
    var subheading = escapeHtml(sidebar.subheading || "");
    var termsHeading = escapeHtml((sidebar.terms && sidebar.terms.heading) || "What to expect");
    var lines = (sidebar.terms && Array.isArray(sidebar.terms.lines) && sidebar.terms.lines) || [];
    var legal = escapeHtml(sidebar.legal_disclaimer || "");

    // Last entry in `lines` is usually a `{ links: {...} }` object — extract
    // it so we can substitute {%IPID%} / {%Policy Wording%} placeholders.
    var linkMap = {};
    var renderableLines = [];
    for (var i = 0; i < lines.length; i++) {
      var ln = lines[i];
      if (ln && typeof ln === "object" && ln.links) {
        Object.assign(linkMap, ln.links);
      } else {
        renderableLines.push(String(ln));
      }
    }

    function renderLine(raw) {
      var tick = false;
      var text = raw;
      if (text.indexOf("{tick}") === 0) {
        tick = true;
        text = text.slice("{tick}".length);
      }
      // Substitute {%Label%} placeholders with anchor tags from linkMap.
      var html = escapeHtml(text).replace(/\{%([^}]+)%\}/g, function (_, label) {
        var url = linkMap[label];
        if (!url) return escapeHtml(label);
        return (
          '<a href="' +
          escapeHtml(url) +
          '" target="_blank" rel="noopener">' +
          escapeHtml(label) +
          "</a>"
        );
      });
      return (
        '<li>' +
        (tick ? SIDEBAR_TICK_SVG : "") +
        '<span>' +
        html +
        "</span>" +
        "</li>"
      );
    }

    var benefitsHtml = renderableLines.map(renderLine).join("");

    content.innerHTML =
      '<div class="loxa-sidebar-content-root">' +
        '<div class="loxa-sidebar-intro">' +
          '<h3>' + header + "</h3>" +
          (subheading
            ? '<p class="loxa-sidebar-subheading">' + subheading + "</p>"
            : "") +
        "</div>" +
        '<div class="loxa-sidebar-option loxa-selected" data-loxa-code="' +
          escapeHtml(plan.code) + '">' +
          '<div class="loxa-sidebar-option-body">' +
            '<div class="loxa-sidebar-option-main">' +
              '<span class="loxa-sidebar-option-circle"></span>' +
              '<span class="loxa-sidebar-option-title">' +
                "5 Year Product Protection" +
              "</span>" +
            "</div>" +
            '<span class="loxa-sidebar-option-price">£' +
              total.toFixed(2) +
            "</span>" +
          "</div>" +
        "</div>" +
        '<div class="loxa-sidebar-terms">' +
          '<h4>' + termsHeading + "</h4>" +
          '<ul>' + benefitsHtml + "</ul>" +
        "</div>" +
        '<div class="loxa-sidebar-actions">' +
          '<button type="button" class="loxa-sidebar-cta" data-loxa-action="add">Add Loxa Protection</button>' +
          '<button type="button" class="loxa-sidebar-remove" data-loxa-action="remove">No thanks</button>' +
        "</div>" +
        (legal
          ? '<div class="loxa-sidebar-legal"><p>' + legal + "</p></div>"
          : "") +
      "</div>";

    // Wire the CTA + remove.
    var cta = content.querySelector('[data-loxa-action="add"]');
    if (cta) cta.addEventListener("click", function () {
      var cb = document.getElementById(CHECKBOX_ID);
      if (cb) {
        cb.checked = true;
        cb.dispatchEvent(new Event("change", { bubbles: true }));
      }
      closeSidebar();
    });
    var removeBtn = content.querySelector('[data-loxa-action="remove"]');
    if (removeBtn) removeBtn.addEventListener("click", function () {
      var cb = document.getElementById(CHECKBOX_ID);
      if (cb) {
        cb.checked = false;
        cb.dispatchEvent(new Event("change", { bubbles: true }));
      }
      closeSidebar();
    });

    // Reflect the current checkbox state in the CTA's label.
    var cbState = document.getElementById(CHECKBOX_ID);
    if (cbState && cbState.checked && cta) {
      cta.textContent = "Continue with Protection";
    }
  }

  function updateTitle(text) {
    var el = document.querySelector("#" + OFFER_ID + " ." + TITLE_CLASS);
    if (el) el.textContent = text;
  }

  function formatTitle(term, premium) {
    return "Add " + term + "-Year Protection - £" + premium.toFixed(2);
  }

  // Reveal or hide the whole offer block (heading + card). Called whenever
  // we know whether the current product is insurable.
  function setOfferVisible(visible) {
    var anchor = document.getElementById(ANCHOR_ID);
    if (!anchor) return;
    if (visible) anchor.classList.add("loxa-ready");
    else anchor.classList.remove("loxa-ready");
  }

  // ─── Quote helpers (via LoxaShopifyDev) ────────────────────────────────────
  function pickInsuranceForTerm(quote, term) {
    if (!quote || !Array.isArray(quote.insurances) || !quote.insurances.length)
      return null;
    var match = quote.insurances.find(function (ins) {
      return String(ins.insurance_term || ins.term) === String(term);
    });
    return match || quote.insurances[0];
  }

  function premiumOf(plan) {
    if (!plan) return 0;
    return typeof plan.insurance_price === "number"
      ? plan.insurance_price
      : parseFloat(plan.insurance_price || "0");
  }

  // Fetch + normalise a quote for a variant. Falls back to /variants/{id}.js
  // for an authoritative title + price (the proxy needs both).
  function fetchQuoteFor(variantId, opts) {
    opts = opts || {};
    var key = String(variantId);
    if (quoteCache[key]) return Promise.resolve(quoteCache[key]);

    var title = opts.title || null;
    var pricePounds = typeof opts.pricePounds === "number" ? opts.pricePounds : null;

    var ctxPromise =
      title && typeof pricePounds === "number"
        ? Promise.resolve({ title: title, pricePounds: pricePounds })
        : fetch("/variants/" + variantId + ".js")
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (v) {
              if (!v) {
                return { title: title || "Product", pricePounds: pricePounds || 0 };
              }
              return {
                title: v.name || v.title || title || "Product",
                pricePounds: typeof v.price === "number" ? v.price / 100 : 0,
              };
            })
            .catch(function () {
              return { title: title || "Product", pricePounds: pricePounds || 0 };
            });

    return ctxPromise.then(function (ctx) {
      return Dev.fetchInsurance(String(variantId), ctx.title, ctx.pricePounds).then(
        function (data) {
          if (!data || data.error) return null;
          var quote = {
            variantId: key,
            productTitle: ctx.title,
            pricePounds: ctx.pricePounds,
            category: data.insurance_category || "Furniture",
            insurances: Array.isArray(data.insurances) ? data.insurances : [],
          };
          quoteCache[key] = quote;
          return quote;
        },
      );
    });
  }

  // ─── Display refresh (per-template) ────────────────────────────────────────
  function refreshMattressDisplay() {
    var vid = displayVariantId();
    if (!vid || vid === lastVariantId) return refreshFrameDisplay();
    lastVariantId = vid;
    var hint = currentVariantInfoFromAnalytics();
    fetchQuoteFor(
      vid,
      hint ? { title: hint.title, pricePounds: hint.pricePounds } : {},
    ).then(function () {
      paintMattressTitle();
    });
  }

  function refreshFrameDisplay() {
    var input = getSelectedFrameInput();
    var newId = input ? String(input.value) : null;
    if (newId === lastFrameVid) return;
    lastFrameVid = newId;
    if (!newId) {
      paintMattressTitle();
      return;
    }
    fetchQuoteFor(newId).then(function () {
      if (newId !== lastFrameVid) return;
      paintMattressTitle();
    });
  }

  function paintMattressTitle() {
    var mq = quoteCache[String(lastVariantId)];
    if (!mq) {
      setOfferVisible(false);
      return;
    }
    var mPlan = pickInsuranceForTerm(mq, DEFAULT_TERM);
    if (!mPlan || !premiumOf(mPlan)) {
      // Product isn't insurable (no quote, no 5-year plan, or zero premium).
      // Hide the whole offer block.
      setOfferVisible(false);
      return;
    }
    var total = premiumOf(mPlan);
    if (lastFrameVid) {
      var fq = quoteCache[String(lastFrameVid)];
      if (fq) {
        var fPlan = pickInsuranceForTerm(fq, DEFAULT_TERM);
        if (fPlan) total += premiumOf(fPlan);
      }
    }
    updateTitle(
      formatTitle(String(mPlan.insurance_term || mPlan.term || DEFAULT_TERM), total),
    );
    setOfferVisible(true);
  }

  function refreshBedframeDisplay() {
    var vid = displayVariantId();
    if (!vid || vid === lastVariantId) return;
    lastVariantId = vid;
    var hint = currentVariantInfoFromAnalytics();
    fetchQuoteFor(
      vid,
      hint ? { title: hint.title, pricePounds: hint.pricePounds } : {},
    ).then(function (q) {
      if (vid !== lastVariantId) return;
      if (!q) {
        setOfferVisible(false);
        return;
      }
      var plan = pickInsuranceForTerm(q, DEFAULT_TERM);
      if (!plan || !premiumOf(plan)) {
        setOfferVisible(false);
        return;
      }
      updateTitle(
        formatTitle(
          String(plan.insurance_term || plan.term || DEFAULT_TERM),
          premiumOf(plan),
        ),
      );
      setOfferVisible(true);
    });
  }

  // ─── /cart/add.js interceptor ─────────────────────────────────────────────
  // Append insurance items into the original payload. ONE ATC, ONE drawer
  // open, ONE bespoke pass.
  function installCartAddInterceptor() {
    // Use native fetch for pass-through calls (non-ATC URLs) to avoid
    // corrupting the call-stack trace that the v2 cart-blocking wrapper
    // relies on for its isLiquidAjaxCartRequest check. Without this, LAC's
    // /cart/change.js and /cart/update.js calls get silently blocked.
    var origFetch = window.fetch.bind(window);
    var nativeFetch = window.__nativeFetch || origFetch;
    window.fetch = function (input, init) {
      try {
        var url =
          typeof input === "string" ? input : (input && input.url) || "";
        if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) return nativeFetch(input, init);

        var method =
          (init && init.method) ||
          (typeof input !== "string" && input.method) ||
          "GET";
        if (String(method).toUpperCase() !== "POST") return nativeFetch(input, init);

        // Our own bypass marker — never re-process.
        var headers = (init && init.headers) || {};
        if (headers[HEADER_MARKER] || headers[HEADER_MARKER.toLowerCase()]) {
          return nativeFetch(input, init);
        }

        // Offer checkbox must be ticked.
        var cb = document.getElementById(CHECKBOX_ID);
        if (!cb || !cb.checked) return nativeFetch(input, init);

        // Parse items[] from body. Only JSON multi-item bodies are
        // processable inline; for other body shapes (FormData / URLSearchParams
        // from a plain product form) we convert to JSON inline.
        var parsed = parseAddBody(init && init.body);
        if (!parsed || !parsed.items.length) return nativeFetch(input, init);

        // Async enrich: build insurance items, append, then call origFetch.
        // Returning a Promise is fine — fetch() always returns a Promise.
        return enrichAndFetch(origFetch, input, init, parsed);
      } catch (e) {
        console.error("[Loxa Nectar] interceptor outer failed", e);
        return nativeFetch(input, init);
      }
    };
  }

  // Parse the body into { items: [...], extras: {sections, sections_url, ...} }
  // so we can append insurance items and rebuild as JSON.
  function parseAddBody(body) {
    try {
      if (!body) return null;
      if (typeof body === "string") {
        var p = JSON.parse(body);
        if (p && Array.isArray(p.items)) {
          return {
            items: p.items.map(function (it) {
              return {
                id: it.id,
                quantity: it.quantity || 1,
                properties: it.properties || {},
                selling_plan: it.selling_plan || null,
              };
            }),
            extras: shallowOmit(p, ["items"]),
          };
        }
        if (p && p.id !== undefined) {
          return {
            items: [
              {
                id: p.id,
                quantity: p.quantity || 1,
                properties: p.properties || {},
                selling_plan: p.selling_plan || null,
              },
            ],
            extras: shallowOmit(p, ["id", "quantity", "properties", "selling_plan"]),
          };
        }
      }
      if (typeof FormData !== "undefined" && body instanceof FormData) {
        var id = body.get("id");
        var qty = parseInt(body.get("quantity") || "1", 10);
        if (id) {
          return {
            items: [
              {
                id: id,
                quantity: isNaN(qty) ? 1 : qty,
                properties: collectFormDataProperties(body),
                selling_plan: body.get("selling_plan") || null,
              },
            ],
            extras: collectFormDataExtras(body),
          };
        }
      }
      if (
        typeof URLSearchParams !== "undefined" &&
        body instanceof URLSearchParams
      ) {
        var id2 = body.get("id");
        var qty2 = parseInt(body.get("quantity") || "1", 10);
        if (id2) {
          return {
            items: [
              {
                id: id2,
                quantity: isNaN(qty2) ? 1 : qty2,
                properties: collectURLSearchParamsProperties(body),
                selling_plan: body.get("selling_plan") || null,
              },
            ],
            extras: collectURLSearchParamsExtras(body),
          };
        }
      }
    } catch (e) {}
    return null;
  }

  function shallowOmit(obj, keys) {
    var out = {};
    for (var k in obj) {
      if (obj.hasOwnProperty(k) && keys.indexOf(k) === -1) out[k] = obj[k];
    }
    return out;
  }

  function collectFormDataProperties(fd) {
    var out = {};
    fd.forEach(function (value, name) {
      var m = name.match(/^properties\[(.+)\]$/);
      if (m) out[m[1]] = value;
    });
    return out;
  }

  function collectURLSearchParamsProperties(usp) {
    var out = {};
    usp.forEach(function (value, name) {
      var m = name.match(/^properties\[(.+)\]$/);
      if (m) out[m[1]] = value;
    });
    return out;
  }

  // Keys that go INTO items[0] in the JSON body — strip them from extras so
  // they don't end up duplicated at the top level.
  var ITEM_KEYS = ["id", "quantity", "selling_plan"];

  // Collect everything in the FormData that ISN'T an item-level field or a
  // `properties[*]` field. These pass through to the JSON body alongside
  // `items[]`. CRITICAL: this includes `sections` and `sections_url` (which
  // LAC adds to its outgoing /cart/add.js request to ask Shopify for
  // rendered section HTML in the response). Without these, LAC has no
  // section HTML to paint the cart drawer with — drawer stays empty.
  function collectFormDataExtras(fd) {
    var out = {};
    fd.forEach(function (value, name) {
      if (/^properties\[/.test(name)) return;
      if (ITEM_KEYS.indexOf(name) !== -1) return;
      // Some fields are Shopify form metadata we don't need but they're
      // also harmless to pass through.
      out[name] = value;
    });
    return out;
  }

  function collectURLSearchParamsExtras(usp) {
    var out = {};
    usp.forEach(function (value, name) {
      if (/^properties\[/.test(name)) return;
      if (ITEM_KEYS.indexOf(name) !== -1) return;
      out[name] = value;
    });
    return out;
  }

  function enrichAndFetch(origFetch, input, init, parsed) {
    // Skip any items that ARE the insurance product itself (defensive — the
    // checkbox tick is meant to be for product ATCs).
    var productItems = parsed.items.filter(function (it) {
      return !isInsuranceVariant(it.id);
    });
    if (!productItems.length) return origFetch(input, init);

    return insuranceMapPromise.then(function (map) {
      if (!map || !map.length) return origFetch(input, init);

      var insuranceItems = [];
      var resolveJobs = productItems.map(function (it) {
        // Try cache first; fall through to inline fetch for unknown variants
        // (upsell modal swap-in, bundler add-ons, anything we haven't pre-quoted).
        var key = String(it.id);
        var quotePromise = quoteCache[key]
          ? Promise.resolve(quoteCache[key])
          : fetchQuoteFor(key);
        return quotePromise.then(function (quote) {
          if (!quote || !quote.insurable && !quote.insurances.length) return;
          var plan = pickInsuranceForTerm(quote, DEFAULT_TERM);
          if (!plan) return;
          var premium = premiumOf(plan);
          if (!premium) return;
          var match = Dev.findInsuranceVariantByPrice(premium, map);
          if (!match || !match.variantId) return;
          var numericId = String(match.variantId).replace(
            "gid://shopify/ProductVariant/",
            "",
          );
          insuranceItems.push({
            id: parseInt(numericId, 10),
            quantity: it.quantity,
            properties: buildInsuranceProps(plan, quote, numericId, key),
          });
        });
      });

      return Promise.all(resolveJobs).then(function () {
        if (!insuranceItems.length) return origFetch(input, init);

        var combined = parsed.items.concat(insuranceItems);
        var bodyOut = Object.assign({}, parsed.extras, { items: combined });

        var newInit = Object.assign({}, init || {}, {
          method: "POST",
          body: JSON.stringify(bodyOut),
          headers: Object.assign({}, init && init.headers, {
            "Content-Type": "application/json",
          }),
        });
        // If the original input is a Request object we can't reuse it — we
        // already rebuilt init.body and headers. Use the URL string instead.
        var urlOut =
          typeof input === "string" ? input : (input && input.url) || "";
        return origFetch(urlOut, newInit).then(function (response) {
          // v2 cart drawer: proactively clear the empty-state class now
          // that items have been added, rather than relying on the
          // liquidAjaxCart.update() → request-end → scheduleCartDrawerRefresh
          // → syncCartDrawerEmptyState chain, which has timing dependencies.
          if (window.radiant?.cartVersion === 'v2' && response.ok) {
            var di = document.querySelector('#CartDrawerV2 .cart-drawer-v2__inner');
            if (di) di.classList.remove('cart-drawer-v2__inner--empty');
          }
          return response;
        });
      });
    });
  }

  function isInsuranceVariant(variantId) {
    // Cheap synchronous check — the insurance map is already resolved by
    // ATC time, so we can match against it. If somehow it isn't, default
    // to false (treat as a normal product item).
    try {
      var map = insuranceMapCache;
      if (!map) return false;
      var id = String(variantId);
      for (var i = 0; i < map.length; i++) {
        var vs = map[i].variants || [];
        for (var j = 0; j < vs.length; j++) {
          if (String(vs[j].id) === id) return true;
        }
      }
    } catch (e) {}
    return false;
  }

  function buildInsuranceProps(plan, quote, insVarNumericId, insuredVariantId) {
    return {
      _loxaInsuranceCodeSep: plan.code,
      _Premium: "£" + premiumOf(plan).toFixed(2),
      _loxaSignature: plan.premium_signature || "",
      _loxaInsuranceProductId: String(insVarNumericId),
      _insuredProductId: String(insuredVariantId),
      "Insured Product": quote.productTitle || "",
      _sumInsured: (quote.pricePounds || 0).toFixed(2),
      _Category: quote.category || "Furniture",
      _loxaTerm: String(plan.insurance_term || plan.term || DEFAULT_TERM),
    };
  }

  // Synchronous mirror of the insurance map (populated once the promise
  // resolves), so isInsuranceVariant() doesn't need to await.
  var insuranceMapCache = null;

  // ─── Variant-change observers ──────────────────────────────────────────────
  // Nectar's theme uses #MainContent swaps for material toggle / upsell
  // flows. When that fires we re-inject the anchor + re-render.
  function attachMainContentObserver() {
    // Only mattress PDPs use data-reload-content to swap #MainContent
    // (material toggle Memory Foam ↔ Hybrid, Classic → Premier upgrade).
    // On bedframe + bundle pages mutations to #MainContent come from
    // unrelated things (LAC section refresh, drawer animations) and don't
    // indicate a product swap — observing them caused us to hide the
    // offer card after ATC.
    if (TEMPLATE !== "mattress") return;

    var main = document.getElementById("MainContent");
    if (!main) {
      setTimeout(attachMainContentObserver, 300);
      return;
    }
    if (main.__loxaObserved) return;
    main.__loxaObserved = true;
    var debounce = null;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (
          mutations[i].type === "childList" &&
          mutations[i].target === main
        ) {
          if (debounce) clearTimeout(debounce);
          debounce = setTimeout(function () {
            debounce = null;
            // Only treat as a product swap when the actual product id
            // has changed. Without this guard ANY mutation in #MainContent
            // (e.g. a section repaint triggered by a cart update) would
            // reset our state and hide the offer card.
            var newProductId =
              window.ShopifyAnalytics &&
              ShopifyAnalytics.meta &&
              ShopifyAnalytics.meta.product &&
              ShopifyAnalytics.meta.product.id;
            if (
              newProductId &&
              String(newProductId) !== String(lastProductId)
            ) {
              lastProductId = String(newProductId);
              handleMainContentSwap();
            }
          }, 200);
          return;
        }
      }
    }).observe(main, { childList: true });
  }

  function handleMainContentSwap() {
    try {
      // The new product's anchor target may exist now; re-mount.
      injectAnchor();
      renderOfferCard("Loading protection…");
      // Stay hidden until the new product's quote resolves.
      setOfferVisible(false);
      // Force a re-quote next tick — new variant id will be in the form.
      lastVariantId = null;
      lastFrameVid = null;
    } catch (e) {
      console.error("[Loxa Nectar] post-swap re-init failed", e);
    }
  }

  // ─── Init ──────────────────────────────────────────────────────────────────
  waitForDev(function (D) {
    Dev = D;
    injectStyles();
    if (!injectAnchor()) return;
    renderOfferCard("Loading protection…");
    // Capture current product id so the MainContent observer can detect
    // an actual product swap (vs. a section repaint from LAC/cart updates).
    try {
      var initialPid =
        window.ShopifyAnalytics &&
        ShopifyAnalytics.meta &&
        ShopifyAnalytics.meta.product &&
        ShopifyAnalytics.meta.product.id;
      if (initialPid) lastProductId = String(initialPid);
    } catch (e) {}
    attachMainContentObserver();

    // Pre-cache the insurance map. It's used at ATC time + by
    // isInsuranceVariant() to short-circuit our own insurance lines if
    // they ever go through the interceptor.
    insuranceMapPromise = Dev.getInsuranceMap().then(function (m) {
      insuranceMapCache = m || [];
      return insuranceMapCache;
    });

    installCartAddInterceptor();

    // Initial display + 200ms polling for in-page variant changes.
    if (TEMPLATE === "mattress") {
      refreshMattressDisplay();
      setInterval(function () {
        refreshMattressDisplay();
        refreshFrameDisplay();
      }, 200);
    } else {
      refreshBedframeDisplay();
      setInterval(refreshBedframeDisplay, 200);
    }
  });
})();
